// extracted by mini-css-extract-plugin
export default {"breadcrumbWrapper":"styles_breadcrumbWrapper__OfTFb","wrapper":"styles_wrapper__fhL91","reportOrder":"styles_reportOrder__NeI6L","bottomCards":"styles_bottomCards__NJqk8"};